var o = ".gator-radio-group-options{padding-inline-start:0}";
export { o as default };